import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const StaffAttendanceForm = () => {
  const [formData, setFormData] = useState({
    staffId: "",
    numberOfDays: 0,
    designation: "",
    paidLeaves: 0,
    halfDays: 0,
    lateEntryDeduction: 0,
    holidays: 0,
    professionalTax: 0,
    bonus: 0,
    commission: 0,
    incentives: 0,
    travelAllowance: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("/api/attendance/staff", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      alert("Staff attendance saved successfully!");
    } else {
      alert("Failed to save staff attendance");
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="staffId">Staff ID</Label>
          <Input
            type="text"
            name="staffId"
            value={formData.staffId}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <Label htmlFor="numberOfDays">Number of Days Worked</Label>
          <Input
            type="number"
            name="numberOfDays"
            value={formData.numberOfDays}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <Label htmlFor="designation">Designation</Label>
          <Input
            type="text"
            name="designation"
            value={formData.designation}
            onChange={handleChange}
            required
          />
        </div>

        {/* Add other fields for Paid Leaves, Holidays, etc. */}

        <div className="flex justify-end mt-4">
          <Button type="submit">Submit Attendance</Button>
        </div>
      </form>
    </div>
  );
};

export default StaffAttendanceForm;
